webpackJsonp([153228935106781],{

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-scot-1.0ea2a733.jpg";

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-scot-2.9cc849e6.jpg";

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-scot-3.6ca86142.jpg";

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-scot-4.68732f0b.jpg";

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Hero-scot.98611fc7.jpg";

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Inbox-scot.a6573253.jpg";

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mailmerge-scot.74dc0814.jpg";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Statistics-scot.d80d9389.jpg";

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ScotQuery = undefined;
	
	var _Hero = __webpack_require__(13);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _ProductBar = __webpack_require__(14);
	
	var _ProductBar2 = _interopRequireDefault(_ProductBar);
	
	var _Grid = __webpack_require__(5);
	
	var _ContentBlock = __webpack_require__(6);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _DividerImage = __webpack_require__(17);
	
	var _DividerImage2 = _interopRequireDefault(_DividerImage);
	
	var _HtmlContainer = __webpack_require__(8);
	
	var _HtmlContainer2 = _interopRequireDefault(_HtmlContainer);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _OrderButton = __webpack_require__(18);
	
	var _OrderButton2 = _interopRequireDefault(_OrderButton);
	
	var _PricingContainer = __webpack_require__(19);
	
	var _PricingContainer2 = _interopRequireDefault(_PricingContainer);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSection = __webpack_require__(7);
	
	var _TextSection2 = _interopRequireDefault(_TextSection);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _HeroScot = __webpack_require__(496);
	
	var _HeroScot2 = _interopRequireDefault(_HeroScot);
	
	var _InboxScot = __webpack_require__(500);
	
	var _InboxScot2 = _interopRequireDefault(_InboxScot);
	
	var _PhoneSecurity = __webpack_require__(40);
	
	var _PhoneSecurity2 = _interopRequireDefault(_PhoneSecurity);
	
	var _StatisticsScot = __webpack_require__(510);
	
	var _StatisticsScot2 = _interopRequireDefault(_StatisticsScot);
	
	var _MailmergeScot = __webpack_require__(505);
	
	var _MailmergeScot2 = _interopRequireDefault(_MailmergeScot);
	
	var _BackgroundScot = __webpack_require__(474);
	
	var _BackgroundScot2 = _interopRequireDefault(_BackgroundScot);
	
	var _BackgroundScot3 = __webpack_require__(475);
	
	var _BackgroundScot4 = _interopRequireDefault(_BackgroundScot3);
	
	var _BackgroundScot5 = __webpack_require__(476);
	
	var _BackgroundScot6 = _interopRequireDefault(_BackgroundScot5);
	
	var _BackgroundScot7 = __webpack_require__(477);
	
	var _BackgroundScot8 = _interopRequireDefault(_BackgroundScot7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    navcolour: {
	      backgroundColor: theme.colours.products.scot
	    },
	    text: {
	      width: "50vw",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        margin: 0,
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "3rem"
	        }
	      }
	    },
	    pricing: {
	      marginBottom: "5rem",
	      width: "35vw",
	      "@media (max-width: 823px)": {
	        marginBottom: "1rem",
	        padding: 0,
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        margin: 0,
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "3rem"
	        }
	      }
	    },
	    pricingContainer: {
	      width: "100%"
	    },
	    contentBox: {
	      minHeight: "100vh"
	    },
	    image: {
	      width: "700px",
	      "@media (max-width: 823px)": {
	        display: "none"
	      }
	    },
	    mobileImage: {
	      width: "325px",
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    }
	  };
	};
	
	var NavTabs = [{
	  tabLink: "#features",
	  tabName: "Features"
	}, {
	  tabLink: "#pricing",
	  tabName: "Pricing"
	}, {
	  tabLink: "/tutorials",
	  tabName: "Tutorials"
	}, {
	  tabLink: "/faq",
	  tabName: "FAQ"
	}, {
	  tabLink: "/contact",
	  tabName: "Support"
	}];
	
	var ScotPage = function ScotPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _ProductBar2.default,
	      {
	        className: classes.navcolour,
	        logoLink: "/scot",
	        logoSrc: "/scot-logo.svg"
	      },
	      NavTabs.map(function (tab) {
	        return _react2.default.createElement(_ProductBar.Tab, { key: tab.tabName, tabLink: tab.tabLink, tabName: tab.tabName });
	      })
	    ),
	    _react2.default.createElement(
	      _Hero2.default,
	      { hero: _HeroScot2.default, withBar: true },
	      _react2.default.createElement(
	        "div",
	        { className: classes.heroTextContainer },
	        _react2.default.createElement(
	          _Hero.HeroText,
	          null,
	          _react2.default.createElement(_Hero.HeroIcon, { src: "/scottish-parliament.svg" }),
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.HeroText.html })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "features" },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _InboxScot2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _InboxScot2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundScot2.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _PhoneSecurity2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _PhoneSecurity2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundScot4.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.ThirdContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _StatisticsScot2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _StatisticsScot2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundScot6.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _MailmergeScot2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _MailmergeScot2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundScot8.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "pricing" },
	      _react2.default.createElement(
	        "div",
	        { className: classes.pricingContainer },
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.pricing },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.PricingSection.html })
	          )
	        ),
	        _react2.default.createElement(
	          _PricingContainer2.default,
	          null,
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstPricingChecklist.html }),
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondPricingChecklist.html }),
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.ThirdPricingChecklist.html })
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(_OrderButton2.default, {
	            eventlabel: "Clicked Scot buy button",
	            mailinfo: "mailto:sales@electedtechnologies.com?subject=Caseworker.scot Sales Enquiry",
	            label: "Order Caseworker Now",
	            phonenumber: "0333 344 1225"
	          })
	        )
	      )
	    )
	  );
	};
	
	ScotPage.propTypes = {
	  classes: _propTypes2.default.object,
	  data: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(ScotPage);
	
	/* global graphql */
	
	var ScotQuery = exports.ScotQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-scot-jsx-f24571b99c4ebf5c7ac5.js